var map = {
	"./bash": 1658,
	"./java": 1659,
	"./json": 1660,
	"./julia": 1661,
	"./python": 1662,
	"./r": 1663,
	"./rust": 1664,
	"./scala": 1665,
	"./shell": 1666,
	"./sql": 1667,
	"./xml": 1668,
	"./yaml": 1669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1657;